import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DefaultValuesService } from '../../../services/defaultvalues.service';
import { SignalRService } from '../../../services/signal-r';
import { SaveService } from '../../../services/save.service';
import { Utils } from '../../../utils/utils';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { ContactListComponent } from './contact-list.component';
import { ContactFilterComponent } from './contact-filter.component';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.less'],
  standalone: false
})
export class ContactsComponent implements OnInit {

    list: ContactInfoHub[] = [];
    subscriptionStage: any;
    subscriptionTenant: any;
    subscriptions: any[] = [];
    showLocalFilter = false;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];
    @ViewChild(ContactListComponent, { static: true }) listComponent!: ContactListComponent;
    @ViewChild(ContactFilterComponent, { static: true }) filterComponent!: ContactFilterComponent;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string
        , private defaults: DefaultValuesService
        , public signalRService: SignalRService
        , private saveService: SaveService
    ) { }

    ngOnInit(): void {
        this.subscriptionStage = this.defaults.stageMessageChanges$.subscribe(() => {
            this.getFilteredContactsByTenant();
            this.listComponent.clonedList = {}
        });
        this.subscriptionTenant = this.defaults.tenantMessageChanges$.subscribe(() => {
            this.getFilteredContactsByTenant();
            this.listComponent.clonedList = {}
        });
        if (this.defaults.tenant) {
            this.getFilteredContactsByTenant();
        }
    }

    ngOnDestroy() {
        this.saveService.removeListener(this);
        this.subscriptionStage.unsubscribe();
        this.subscriptionTenant.unsubscribe();
        this.subscriptions.forEach(x => x.unsubscribe())
    }

    getFilteredContactsByTenant() {
        const filter: ContactsFilter = {
            ContactID: this.filterComponent.contactIds,
            ContactType: this.filterComponent.contactTypes,
            ContactPhone: this.filterComponent.contactPhones,
            ContactEMail: this.filterComponent.contactEMails,
            ContactName: this.filterComponent.contactNames,
            ContactFirstName: this.filterComponent.contactFirstNames,
            ContactLastName: this.filterComponent.contactLastNames,
            ContactPosition: this.filterComponent.contactPositions,
        }
        Utils.httpGetContacts(
            this.http
            , this.baseUrl
            , filter
            , this
            , function (tthis: ContactsComponent, list: ContactInfoHub[]) {
                tthis.list = list;
                if (filter.ContactName.length < 1 && filter.ContactFirstName.length < 1 && filter.ContactLastName.length < 1
                    && filter.ContactID.length < 1 && filter.ContactEMail.length < 1 && filter.ContactPhone.length < 1
                    && filter.ContactPosition.length < 1 && filter.ContactType.length < 1)
                    tthis.showLocalFilter = false;
                else
                    tthis.showLocalFilter = true;
            }
            , function (error: any) {
                //console.log(error)
            }
        )
    }

    onReload() {
        this.getFilteredContactsByTenant();
        this.listComponent.clonedList = {}
        this.saveService.showSaveButton(false)
    }

    downloadContactsFiltered() {
        this.signalRService.startConnection(0).then(() => {
            this.signalRService.addDownloadDataListener();
            this.signalRService.addStatusTracesListener();
            this.signalRService.addFileNameListener();
            this.signalRService.addExceptionListener();
            const filter: ContactsFilter = {
                ContactID: this.filterComponent.contactIds,
                ContactType: this.filterComponent.contactTypes,
                ContactPhone: this.filterComponent.contactPhones,
                ContactEMail: this.filterComponent.contactEMails,
                ContactName: this.filterComponent.contactNames,
                ContactFirstName: this.filterComponent.contactFirstNames,
                ContactLastName: this.filterComponent.contactLastNames,
                ContactPosition: this.filterComponent.contactPositions,
            }
            Utils.httpDownloadContacts(
                this.http,
                this.baseUrl,
                this.defaults.tenant,
                filter,
                this,
                null
            )
            return;
        });
    }
}
